// import React from 'react'
// import "./Contact_us.css"
// import Common_breadcrumb from '../common_components/common-breadcrumb/Common_breadcrumb';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
// import { Button, Form } from 'react-bootstrap';
// import { Link } from 'react-router-dom';

// function Contact_us() {
//     const breadcrumbsData = [
//         { name: "HOMEPAGE", href: "/" },
//         { name: "CONTACT US", active: true }
//     ];
//     return (
//         <>
//             <section className='Contact_us'>
//                 <Common_breadcrumb
//                     pageName="CONTACT US"
//                     bgImage="/assets/images/Contact_Us/bg/bg.png"
//                     breadcrumbs={breadcrumbsData}
//                 />

//                 <div className='Contact_us_form_holder '>
//                     <div className="container">
//                         <div className="form_section">
//                             <div className="row align-items-center me-0 ms-0">
//                                 <div className="col-md-6 p-0">
//                                     <div className="info_section">
//                                         <div className="heading_text_holder">
//                                             <h2>REACH OUT ANYTIME, WE’RE HERE</h2>
//                                         </div>

//                                         <div className="info_holder">

//                                             <div className='info_text'>
//                                                 <div className="icon_holder">
//                                                     <FontAwesomeIcon icon={faEnvelope} />
//                                                 </div>
//                                                 <div className="text_holder">
//                                                     {/* Email link */}
//                                                     <Link href="mailto:admin@mymds.co.in"> <p>admin@mymds.co.in</p></Link>
//                                                 </div>
//                                             </div>

//                                             <div className='info_text'>
//                                                 <div className="icon_holder">
//                                                     <FontAwesomeIcon icon={faPhone} />
//                                                 </div>
//                                                 <div className="text_holder">
//                                                     {/* Phone link */}
//                                                     <Link href="tel:+919876543210"><p>+91 9145566955</p></Link>
//                                                 </div>
//                                             </div>

//                                         </div>

//                                         <div className="follow_on">
//                                             <div className="heading_holder">
//                                                 <h4>Follow us on:</h4>
//                                             </div>

//                                             <div className="social_img_holder">
//                                                 {/* Facebook */}
//                                                 <div className="img_hodler">
//                                                     <a href="https://www.facebook.com/profile.php?id=61578144719709" target="_blank" rel="noopener noreferrer">
//                                                         <img src="/assets/images/Contact_Us/social_media/facebook.png" alt="facebook" className='social_img' />
//                                                     </a>
//                                                 </div>

//                                                 {/* YouTube */}
//                                                 <div className="img_hodler">
//                                                     <a href="https://www.youtube.com/@My_MDS_India" target="_blank" rel="noopener noreferrer">
//                                                         <img src="/assets/images/Contact_Us/social_media/youtube.png" alt="youtube" className='social_img' />
//                                                     </a>
//                                                 </div>

//                                                 {/* Instagram */}
//                                                 <div className="img_hodler">
//                                                     <a href="https://www.instagram.com/my_mds_india/" target="_blank" rel="noopener noreferrer">
//                                                         <img src="/assets/images/Contact_Us/social_media/instagram.png" alt="instagram" className='social_img' />
//                                                     </a>
//                                                 </div>

//                                                 {/* Twitter */}
//                                                 <div className="img_hodler">
//                                                     <a href="https://x.com/My_MDS_India" target="_blank" rel="noopener noreferrer">
//                                                         <img src="/assets/images/Contact_Us/social_media/twitter.png" alt="twitter" className='social_img' />
//                                                     </a>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                     </div>
//                                 </div>

//                                 <div className="col-md-6 p-0">
//                                     <div className="form_holder">
//                                         <Form>
//                                             <Form.Group className="mb-3" controlId="formBasicEmail">
//                                                 <Form.Control type="email" placeholder="Enter Full Name" />

//                                             </Form.Group>

//                                             <Form.Group className="mb-3" controlId="formBasicPassword">
//                                                 <Form.Control type="password" placeholder="Enter Mobile No." />
//                                             </Form.Group>

//                                             <Form.Group className="mb-3" controlId="formBasicPassword">
//                                                 <Form.Control type="password" placeholder="Alternate Mobile No." />
//                                             </Form.Group>

//                                             <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
//                                                 <Form.Control as="textarea" rows={3} placeholder='Enter Message' />
//                                             </Form.Group>

//                                             <Button type="submit" className='search_btn'>
//                                                 Submit
//                                             </Button>
//                                         </Form>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </div>


//             </section>
//         </>
//     )
// }

// export default Contact_us





import React, { useState } from "react";
import "./Contact_us.css";
import Common_breadcrumb from "../common_components/common-breadcrumb/Common_breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faLocationDot, faMapLocationDot, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import classNames from "classnames";
import Successfull_Lottie from "../animation/Successfull_Lottie/Successfull_Lottie";
import {
    Create
} from "../../features/admin/contactus/contact/Slice";
function Contact_us() {
    const navigate = useNavigate();
    const breadcrumbsData = [
        { name: "HOMEPAGE", href: "/" },
        { name: "CONTACT US", active: true },
    ];
    const dispatch = useDispatch();
    const {
        control,
        register,
        handleSubmit,
        getValues,
        formState: { errors },
    } = useForm();

    const [showMap, setShowMap] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const toggleMap = () => setShowMap(!showMap);


    const onSubmit = async (data) => {
        // console.log("Form submitted with:", data);
        // console.log("datadatadatadatadata", data)
        try {

            const cleanedMobile = data.mobile_no.replace(/\D/g, "").slice(2);
            const payload = {
                name: data?.name || "",
                email: data?.email || "",
                mobile_no: cleanedMobile || "",
                alternate_no: data?.alternate_no || "",
                message: data?.message || "",
            };

            // console.log("Payload going to slice:", payload);

            const res = await dispatch(Create(payload)).unwrap();
// console.log("RESSSSSSSSSSSSSSSSS",res);

            if (res?.success) {
                setFormSubmitted(true);
                alert(res?.data)
                setTimeout(() => {
                    navigate("/");
                    setFormSubmitted(false);
                }, 3000);
            } else {
                console.error("Form submission failed");
            }
        } catch (err) {
            console.error("Submission error:", err);
        }
    };



    // const onSubmit = async (data) => {
    //     console.log("Form submitted with:", data);

    //     const htmlFormat = `
    //   <div>
    //     <h2>New Contact Form Submission</h2>
    //     <p>Name: ${data.name}</p>
    //     <p>Email: ${data.email}</p>
    //     <p>Phone: ${data.contact_no}</p>
    //     <p>Alternate Phone: ${data.alt_contact}</p>
    //     <p>Message: ${data.message}</p>
    //   </div>
    // `;

    //     try {
    //         const payload = {
    //             email: "admin@mymds.co.in",
    //             subject: "New Contact Form Submission",
    //             html: htmlFormat,
    //             key: "YourKeyHere",
    //         };

    //         const response = await fetch("https://emailservices.hostelbliss.com:3301/common-email", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(payload),
    //         });

    //         if (response.ok) {
    //             setFormSubmitted(true);
    //             setTimeout(() => {
    //                 navigate("/");
    //                 setFormSubmitted(false);
    //             }, 3000);
    //         } else {
    //             console.error("Form submission failed");
    //         }
    //     } catch (err) {
    //         console.error("Submission error:", err);
    //     }
    // };

    return (
        <section className="Contact_us">
            <Common_breadcrumb pageName="CONTACT US" bgImage="/assets/images/Contact_Us/bg/bg.png" breadcrumbs={breadcrumbsData} />

            <div className="Contact_us_form_holder">
                <div className="container">
                    <div className="form_section">
                        <div className="row align-items-center me-0 ms-0">
                            {/* Info Section */}
                            <div className="col-md-6 p-0">
                                <div className="info_section">
                                    <div className="heading_text_holder">
                                        <h2>REACH OUT ANYTIME, WE’RE HERE</h2>
                                    </div>

                                    <div className="info_holder">

                                        <div className='info_text'>
                                            <div className="icon_holder">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                            <div className="text_holder">
                                                {/* Email link */}
                                                <Link href="mailto:admin@mymds.co.in"> <p>admin@mymds.co.in</p></Link>
                                            </div>
                                        </div>

                                        <div className='info_text'>
                                            <div className="icon_holder">
                                                <FontAwesomeIcon icon={faPhone} />
                                            </div>
                                            <div className="text_holder">
                                                {/* Phone link */}
                                                <Link href="tel:+919876543210"><p>+91 9145566955</p></Link>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="follow_on">
                                        <div className="heading_holder">
                                            <h4>Follow us on:</h4>
                                        </div>

                                        <div className="social_img_holder">
                                            {/* Facebook */}
                                            <div className="img_hodler">
                                                <a href="https://www.facebook.com/profile.php?id=61578144719709" target="_blank" rel="noopener noreferrer">
                                                    <img src="/assets/images/Contact_Us/social_media/facebook.png" alt="facebook" className='social_img' />
                                                </a>
                                            </div>

                                            {/* YouTube */}
                                            <div className="img_hodler">
                                                <a href="https://www.youtube.com/@My_MDS_India" target="_blank" rel="noopener noreferrer">
                                                    <img src="/assets/images/Contact_Us/social_media/youtube.png" alt="youtube" className='social_img' />
                                                </a>
                                            </div>

                                            {/* Instagram */}
                                            <div className="img_hodler">
                                                <a href="https://www.instagram.com/my_mds_india/" target="_blank" rel="noopener noreferrer">
                                                    <img src="/assets/images/Contact_Us/social_media/instagram.png" alt="instagram" className='social_img' />
                                                </a>
                                            </div>

                                            {/* Twitter */}
                                            <div className="img_hodler">
                                                <a href="https://x.com/My_MDS_India" target="_blank" rel="noopener noreferrer">
                                                    <img src="/assets/images/Contact_Us/social_media/twitter.png" alt="twitter" className='social_img' />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Form Section */}
                            <div className="col-md-6 p-0">
                                <div className="form_holder">
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Full Name*"
                                                maxLength={15}
                                                {...register("name", {
                                                    required: "Name is required",
                                                    pattern: {
                                                        value: /^[A-Za-z\s]{1,15}$/,
                                                        message: "Only alphabets allowed (max 15 characters)",
                                                    },

                                                })}
                                                className={classNames({ "is-invalid": errors?.name })}
                                            />
                                            {errors?.name && <span className="invalid-feedback d-block">{errors.name.message}</span>}
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter Email*"
                                                {...register("email", {
                                                    required: "Email is required",
                                                    pattern: {
                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                        // message: "Invalid email address",
                                                    },
                                                })}
                                            />
                                            {errors?.email && <span className="invalid-feedback d-block">{errors.email.message}</span>}
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Controller
                                                name="mobile_no"
                                                control={control}
                                                rules={{
                                                    required: "Contact no is required",
                                                    validate: (value) => {
                                                        const onlyNumbers = value.replace(/\D/g, ""); // remove + and spaces
                                                        const numberWithoutCountry = onlyNumbers.substring(2); // remove "91"
                                                        return numberWithoutCountry.length === 10 || "Invalid phone number";
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <PhoneInput
                                                        {...field}
                                                        country={"in"}
                                                        enableSearch={true}
                                                        disabled={false}
                                                        placeholder="Enter Contact Number*"
                                                        countryCodeEditable={false}
                                                        inputProps={{
                                                            required: true
                                                        }}
                                                        onChange={(value) => {
                                                            // restrict input to +91 + 10 digits max
                                                            const onlyNumbers = value.replace(/\D/g, "");
                                                            if (onlyNumbers.startsWith("91")) {
                                                                const numberWithoutCountry = onlyNumbers.substring(2, 12);
                                                                field.onChange(`+91${numberWithoutCountry}`);
                                                            } else {
                                                                field.onChange("+91");
                                                            }
                                                        }}
                                                        className={classNames({ "is-invalid": errors?.mobile_no })}
                                                    />
                                                )}
                                            />
                                            {errors?.mobile_no && (
                                                <span className="invalid-feedback d-block">
                                                    {errors.mobile_no.message}
                                                </span>
                                            )}
                                        </Form.Group>


                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                type="text"
                                                maxLength={10}
                                                placeholder="Alternate Mobile No."
                                                {...register("alternate_no", {
                                                    pattern: {
                                                        value: /^[0-9]{10}$/,
                                                        message: "Alternate mobile must be 10 digits",
                                                    },
                                                    onChange: (e) => {
                                                        // Remove anything that is NOT a digit
                                                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                                    },
                                                })}
                                                className={classNames({ "is-invalid": errors?.alternate_no })}
                                            />
                                            {errors?.alternate_no && (
                                                <span className="invalid-feedback d-block">
                                                    {errors.alternate_no.message}
                                                </span>
                                            )}
                                        </Form.Group>


                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter Message*"
                                                {...register("message", { required: "Message is required" })}
                                                className={classNames({ "is-invalid": errors?.message })}
                                            />
                                            {errors?.message && <span className="invalid-feedback d-block">{errors.message.message}</span>}
                                        </Form.Group>

                                        {!formSubmitted ? (

                                            <Button type="submit" className='search_btn'>
                                                Submit
                                            </Button>
                                        ) : (
                                            <div className="success_div">
                                                <Successfull_Lottie successText="Message Sent Successfully" />
                                            </div>
                                        )}
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            {showMap && (
                <div className="map show">
                    <iframe
                        className="gmap_iframe"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight="0"
                        marginWidth="0"
                        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
                    ></iframe>
                    <div className="close">
                        <FontAwesomeIcon icon={faCircleXmark} className="close-icon" onClick={toggleMap} />
                    </div>
                </div>
            )}
        </section>
    );
}

export default Contact_us;
